module.exports = __webpack_public_path__ + "img/Jdiamonds.94172d69.jpg";